import { printInvoice } from './print.helper';

/**
 * Fetches the total amount of an invoice and returns it.
 * @param orderNumber - The order number of the invoice to fetch.
 * @returns The total amount of the invoice.
 * @throws An error if there was a problem printing the invoice.
 */
export const fetchPrintInvoiceTotalAmount = async (orderNumber: string) => {
  let totalAmount = 0;
  try {
    // TODO: Should be getting invoice html from subscription payload to pass into below function so we don't have to fetch.
    const printInvoiceCallback = (invoiceTotal: number) => {
      totalAmount += invoiceTotal;
    };
    await printInvoice(orderNumber, undefined, printInvoiceCallback);
    return totalAmount;
  } catch (error) {
    console.error(`Error printing invoice for order ${orderNumber}: ${error}`);
    return totalAmount;
  }
};
